import { StyleSheet } from 'react-native'
import theme from '../../../theme'
import { colorButtonTextEnabled } from '../../../themeConstants'

const styles = StyleSheet.create({
    contentContainer: {
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 12,
    },
    mediaContainer: {
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    buttonContainer: {
        flexDirection: 'column',

        padding: 12,
        bottom: 15,
        width: '100%',
    },
    buttonContainer2: {
        padding: 5,
        width: '100%',
        flex: 1,
    },
    mainButton: {
        marginHorizontal: 12,
        backgroundColor: theme.colors.colorPrimary,
        padding: 10,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    mainButtonText: {
        fontSize: 16,
        color: colorButtonTextEnabled,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    goOutBlock: {
        marginTop: 20,
        marginBottom: 12,
        alignItems: 'center',
    },
    goOutText: {
        fontSize: 16,
        color: theme.colors.error,
        fontWeight: 'bold',
    },
    borderButton: {
        margin: 12,
        backgroundColor: 'white',
        borderWidth: 2,
        borderColor: theme.colors.colorPrimary,
        padding: 8,
        borderRadius: 10,
    },
    borderButtonText: {
        fontSize: 16,
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    messageContainer: {
        alignItems: 'center',
        padding: 10,
        marginBottom: 10,
        borderRadius: 5,
    },
    imageAsset: {
        width: 120,
        height: 120,
    },
    titleText: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
        marginTop: 10,
        paddingHorizontal: 25,
    },
    subtitleText: {
        fontSize: 15,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
        marginTop: 10,
        paddingHorizontal: 25,
    },
    descriptionText: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingHorizontal: 15,
    },
    descriptionTextBis: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingHorizontal: 15,
        paddingBottom: 12,
    },
    inputBlock: {
        flexDirection: 'row',
        width: '95%',
        height: 120,
        borderWidth: 0.5,
        borderRadius: 10,
        borderColor: theme.colors.mediumGray,
        backgroundColor: 'white',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 20,
        marginHorizontal: 12,
        marginBottom: 140,
    },
    input: {
        flex: 1,
        height: '90%',
        fontSize: 15,
        color: theme.colors.textPrimary,
        textAlignVertical: 'top',
    },
    imageAssetFullSheet: {
        width: 140,
        height: 140,
    },
    titleTextFullSheet: {
        fontSize: 21,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
        marginTop: 10,
        paddingHorizontal: 25,
    },
    descriptionTextFullSheet: {
        fontSize: 19,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        lineHeight: 26,
        paddingHorizontal: 25,
    },

    spacer: {
        height: 40,
    },
})

export default styles
